import Applicants from "./Applicants";
import PreGrant from "./PreGrant";
import Grantees from "./Grantees";
import Forms from "./Forms";


const modules = [
  {
    module: Applicants,
    path: "/applicants",
    headerText: "Applicants",
  },
  {
    module: PreGrant,
    path: "/pregrant",
    headerText: "Pre Grant",
  },
  {
    module: Grantees,
    path: "/grantees",
    headerText: "Grantees",
  },
  {
    module: Forms,
    path: "/forms",
    headerText: "Forms",
  },
];

export default modules;
